<script>
import { isRmtEnv } from '@/core';
export default {
  name: 'Ad',
  props: {
    /**
     * [
     *  {id:'', images: [{url: ''}], action: ''}
     * ]
     * */

    data: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toUrl(ad) {
      if (!ad.action) return;
      if (ad.action.startsWith('rmt://')) {
        if (isRmtEnv()) {
          window.rmt?.openAction({
            actionUrl: ad.action,
            closing: false
          });
        }
      } else {
        window.location.href = ad.action;
      }
    }
  },
  render() {
    return this.show && this.data && (this.data || []).length ? (
      <div class="ad-slot-wrap">
        <van-swipe autoplay={3000} indicator-color="white">
          {this.data.map((ad) => {
            return ad.images.length ? (
              <van-swipe-item>
                <div class="content-wrap">
                  <van-image
                    fit="cover"
                    width="100%"
                    height="100%"
                    onclick={() => {
                      this.toUrl(ad);
                    }}
                    src={ad.images[0].url + '?imageMogr2/auto-orient/thumbnail/600x600>'}
                  />
                </div>
              </van-swipe-item>
            ) : null;
            // <div class="tip-box">广告</div>
          })}
        </van-swipe>
      </div>
    ) : null;
  }
};
</script>
